import React from 'react';

/**
 * Icon — maps the string icon names used throughout the app (e.g. "Folder",
 * "CreditCard", "Bot") to glyphs. The codebase historically rendered these
 * names as literal TEXT (no icon library was ever installed), which made the
 * admin surfaces look broken. This component renders a consistent emoji glyph
 * (matching the emoji style already used elsewhere in the app) and, crucially,
 * falls back to an empty string — never the raw name — so an unmapped icon
 * degrades to blank instead of showing "Folder" as text.
 */
const GLYPHS = {
  // stat cards / nav
  Folder: '📁', Eye: '👁️', Dollar: '💵', Receipt: '🧾', Bell: '🔔',
  Settings: '⚙️', Palette: '🎨', CreditCard: '💳', Users: '👥', User: '👤',
  Plug: '🔌', Cloud: '☁️', Message: '💬', Chart: '📊', Bot: '🤖',
  Upload: '⬆️', Gift: '🎁', Check: '✅', Plus: '➕', Search: '🔍',
  Bill: '💳', Home: '🏠', Building: '🏢', File: '📄', Document: '📄',
  Clock: '⏱️', Calendar: '📅', Mail: '✉️', Phone: '📞', Star: '⭐',
  Warning: '⚠️', Info: 'ℹ️', Lock: '🔒', Trash: '🗑️', Edit: '✏️',
  Download: '⬇️', Send: '📤', Link: '🔗', Tag: '🏷️', Flag: '🚩',
  // rewards
  Coffee: '☕', Drink: '🥤', Package: '📦', Palm: '🌴', Pizza: '🍕',
  Baseball: '⚾', Points: '⭐', Trophy: '🏆', Medal: '🏅', Target: '🎯',
};

export default function Icon({ name, className = '', style }) {
  const glyph = GLYPHS[name] || '';
  return (
    <span className={className} style={style} role="img" aria-label={name || 'icon'}>
      {glyph}
    </span>
  );
}

export { GLYPHS };
